import { useEffect, useState, useRef } from "react";
import config from "../../../config";
import labels from "../../../config/labels";
import { componentCheckSize } from "../../../utils/helperServices";
import { Col, connect, Container, CustomContainer, Row } from "../../atoms/DependencyHelper";
import SnackBar from "../../atoms/snackBar/SnackBar";
import HomeTabs from "../../molecules/homeTabs/HomeTabs";
import MoreUpgradeDeals from "../../molecules/MoreUpgradeDeals/MoreUpgradeDeals";
import DealListContainer from "../dealListContainer/DealListContainer";
import PastUsage from "../PastUsage/PastUsage";
import UpgradeBenifits from "../upgradeBenifits/UpgradeBenifits";
import UpgradeDealsGrid from "../UpgradeDealsGrid/UpgradeDealsGrid";
import UpgradePageFilters from "../upgradePageFilters/UpgradePageFilters";
import styles from "./UpgradeDealsPageContainer.module.scss";
import UpgradeInfoBanner from "../../molecules/UpgradeInfoBanner/UpgradeInfoBanner";
import { displayHideUpgradeModal, generateOTP } from "../../../Redux/actions/upgradeAction";
import * as Analytics from "../../../services/analyticsUtag";
import { MOBILE_WIDTH } from "../../../config/constants";
import WhitePill from "../../atoms/whitePill/WhitePill";

const UpgradeDealsPageContainer = (props) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const imgUrl = `${imagePrefix}/assets/images/warning-black.svg`;
  const isTablet = componentCheckSize() < 992;
  const isMobile = componentCheckSize() < MOBILE_WIDTH;
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [selectedAlternative, setSelectedAlternative] = useState();
  const [isApiError, setIsApiError] = useState(false);
  const [isRemovePill, setIsRemovePill] = useState(false);
  let sectionReference = useRef(null);

  const OnClickScrollViewElement = () => {
    if (sectionReference.current) {
      if (isMobile) {
        sectionReference.current.scrollIntoView(true);
      }

    }
  }

  //saved for testing purposes
  const testData = {
    mainText: "Yes! You can upgrade right now.",
    subText: "The wait is finally over! Scroll down to choose the perfect deal for you",
    bannerInfo: "This is the number you can upgrade right now",
    imagePath: "http://localhost:1434/assets/images/close-black.svg",
    msisdn: [
      { label: "143445254", upgradeable: true },
      { label: "999999999", upgradeable: true },
      { label: "333333333", upgradeable: true },
      { label: "444444444", upgradeable: true },
      { label: "444444444", upgradeable: true }
    ]
  }

  const closeSnackBar = () => {
    setShowSnackBar(false);
  };

  useEffect(() => {
    if (props.dealSkus?.length == 0 && props.loadingProducts && !props?.productList) {
      setShowSnackBar(true);
      setIsApiError(true);
    }
    if (!props.loadingProducts && props?.productList?.products?.items) {
      if (props?.productList?.products?.items?.length) {
        setShowSnackBar(false);
        setIsApiError(false);
      } else {
        setShowSnackBar(true);
        Analytics.link({
          page_name: "shopping: upgrade: recommended deals",
          page_form_event: "error",
          page_errors: "We seem to be having some issues retrieving your recommended deals right now. Please try again later.",
          page_error_type: "page"
        });
        setIsApiError(true);
      }
    }
  }, [props?.productList?.products?.items, props.loadingProducts]);
  const [activeTab, setActiveTab] = useState("Recommended deals");

  const tabsToRender = [
    {
      key: 1,
      title: "Recommended deals",
      component: (
        <>
          {isTablet && (
            <CustomContainer className="heading-and-filter-button-container">
              <Row>
                <Col xs={12}>
                  <div className={styles["heading-and-filter-button-wrapper"]}>
                    <h2 className={styles["just-heading"]}>Just4You deals</h2>

                    {!props.dealApiError && (
                      <CustomContainer className={styles["filters-modal-button"]} onClick={() => props.setShowModal(true)}>
                        <img
                          className={styles["button-image"]}
                          height={24}
                          src={`${imagePrefix}/assets/images/filter.svg`}
                          alt="filter"
                        />
                        <div className={styles["button-label"]}>
                          {"Filter deals"}
                        </div>
                      </CustomContainer>
                    )}
                  </div>
                </Col>
              </Row>
            </CustomContainer>
          )}

          <>

            {!isTablet && !props.dealApiError && (<UpgradePageFilters
              setSelectedContractType={props.setSelectedContractType}
              setSelectedBrand={props.setSelectedBrand}
              setSelectedModel={props.setSelectedModel}
              selectedContractType={props.selectedContractType}
              selectedBrand={props.selectedBrand}
              selectedModel={props.selectedModel}
              brands={props.brands}
              models={props.models}
              planData={props.planData}
              searchDeals={props.searchDeals}
            />
            )}
            {(isMobile || isTablet) && (
              <>
                {(props.isContractTypeFilterApplied && props.selectedContractType) && (
                  <WhitePill
                    style={{ marginRight: "0.5rem", marginTop: "0.5rem" }}
                    name={props.selectedContractType}
                    removeBtnHandler={() =>
                      removeFilter("contractType")
                    }
                  />
                )}
                {(props.isBrandFilterApplied && props.selectedBrand) && (
                  <WhitePill
                    style={{ marginRight: "0.5rem", marginTop: "0.5rem" }}
                    name={props.selectedBrand}
                    removeBtnHandler={() =>
                      removeFilter("brand")
                    }
                  />
                )}
                {(props.isModelFilterApplied && props.selectedModel) && (
                  <WhitePill
                    style={{ marginRight: "0.5rem", marginTop: "0.5rem" }}
                    name={props.selectedModel}
                    removeBtnHandler={() =>
                      removeFilter("model")
                    }
                  />
                )}
              </>
            )}  
            {
              props?.productList?.products?.items?.length > 0 ? (
                <CustomContainer className="deal-cards-container">
                  <Row>
                    <Col lg={12} xl={12} className={isTablet ? "pb-5" : "pl-2"} ref={sectionReference}>
                      <DealListContainer
                        setActiveTab={setActiveTab}
                        items={props.productList?.products?.items}
                        isDealGridPage={false}
                        sortBy={props.setSortBy}
                        pageInfo={props.productList?.products?.page_info}
                        updateCurrentPage={props.updateCurrentPage}
                        totalItemsCount={props.productList?.products?.total_count}
                        selectedSortVal={props.sortBy}
                        spanXl="3"
                        dealButtonTxt={labels.lbl_deal_selection_page_card_btn}
                        isDealSelection={true}
                        isDSE={true}
                        pageName="upgrade"
                        resetDealSelectionFilter={props.resetFilter}
                        analyticsHandleSortFilter={props.analyticsHandleSortFilter}
                        OnClickScrollViewElement={OnClickScrollViewElement}
                        upgradeCheckDone={true}
                        showFiltersModal={props.setShowModal}
                      />
                      <UpgradeDealsGrid />
                    </Col>
                  </Row>
                </CustomContainer>
              ) : (
                <>
                  {isApiError && (
                    <CustomContainer className={styles["error-message"]}>
                      <img
                        src={imgUrl}
                        width={17}
                        height={17}
                        className={styles["error-image"]}
                      />
                      <span> {"We seem to be having some issues retrieving your recommended deals right now. Please try again later."}
                      </span>
                    </CustomContainer>
                  )}
                  <CustomContainer className={styles["button-container"]}>
                    <UpgradeDealsGrid />
                  </CustomContainer>
                </>

              )
            }

          </>

        </>
      ),
    },
    {
      key: 2,
      title: "Past usage & spend",
      component: (
        <Container className={styles["pastusage-container"]}>
          <PastUsage selectedNumber={props.selectedNumber} setSelectedNumber={props.setSelectedNumber} pastUsageParagraph={props.pastUsageParagraph} setActiveTab={setActiveTab} />
        </Container>
      )
    },
    !isTablet &&
    {
      key: 3,
      title: "Why upgrade online ?",
      component: props.simpleCardData && (
        <Container className={styles["benifits-container"]}>
          <UpgradeBenifits simpleCardData={props.simpleCardData} />
        </Container>
      ),
    },

  ];

  useEffect(() => {
    if(isRemovePill) {
      props.searchDeals();
      setIsRemovePill(false);
    }
  },[isRemovePill]);

  const removeFilter = (filterType) => {
    switch(filterType) {
      case "contractType":
        props.setSelectedContractType("");
        props.setSelectedBrand();
        props.setSelectedModel();
        break;
      case "brand":
        props.setSelectedBrand();
        break;
      case "model":
        props.setSelectedModel();
        break;
      default:
        break;
    }
    setIsRemovePill(true);
  }

  return (
    <Container className={styles["dse-container"]}>
      <UpgradeInfoBanner
        data={testData}
        infoBold={false}
        selectedNumber={props.selectedNumber}
        setSelectedNumber={props.setSelectedNumber}
      />

      <HomeTabs
        tabsContent={tabsToRender}
        variant={"black-with-line"}
        tabType={"tab"}
        alignment={"left"}
        analytics={{ link_name: "shopping: upgrade: recommended deals:" }}
        selectedTab={activeTab}
        selectTabHandler={setActiveTab}
        page={"upgrade"}
      ></HomeTabs>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  showUpgradeModal: state.upgrade.showModal,
  allUpgradesData: state.upgrade.allUpgradesData,
  upgradeResponse: state.upgrade.selectedUpgradeResponse,
});

export default connect(mapStateToProps, { generateOTP, displayHideUpgradeModal })(UpgradeDealsPageContainer);